import { render } from "./BadgesContent.vue?vue&type=template&id=473e1392"
import script from "./BadgesContent.vue?vue&type=script&lang=js"
export * from "./BadgesContent.vue?vue&type=script&lang=js"

import exportComponent from "/Users/dorivaldodossantos/Documents/projectos/meus/ggmf/ggmf_front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__